/*
 * @Author: wzc
 * @Date: 2024-06-29 10:42:36
 * @LastEditors: wzc
 * 超赛平台 base mixins 奥运会
 * @LastEditTime: 2024-06-29 19:11:02
 */

import bigSports_mixin from '@mixins/compreSportsMeet/SOG/bigSportsList_mixin.js'
export default {
  mixins: [bigSports_mixin],
  data() {
    return {
      containerFullClassName: 'containerFull_CSMeet_SOG',
      defaultPath: ['compreSportsMeet', 'olympicGames', 'schedule'],
      axiosBaseUrl: '/sog',
      sportCompetitionType: 'compreSportsMeet_SOG', //暂时不加具体中网|汤尤杯这种赛事区别，如果需要后面补字段即可【tennis_chinaOpen,badminton_thomasAndUber, compreSportsMeet_ASG】
      themeSeasonArr: [
        {
          sidArr: ['SOG2024', 'SOG2020'],
          themeIndex: 0,
        },
      ],
    }
  },
}
